import { combatTypes } from '../constants';

const initialState = {
  upcoming: {},
  staticData: {},
  onboardingPreferences: {},
  details: {},
  contestRating: {},
  myRating: {}
};

const reducerMap = {
  [`${combatTypes.FETCH_CONTEST_INFO}_SUCCESS`](state, { goalUID, result }) {
    return {
      ...state,
      staticData: {
        ...state.staticData,
        [goalUID]: result
      }
    };
  },
  [`${combatTypes.FETCH_CONTEST_RATING}_SUCCESS`](state, { goalUID, result }) {
    return {
      ...state,
      contestRating: {
        ...state.contestRating,
        [goalUID]: result
      }
    };
  },
  [`${combatTypes.FETCH_MY_RATING}_SUCCESS`](state, { goalUID, result }) {
    return {
      ...state,
      myRating: {
        ...state.myRating,
        [goalUID]: result
      }
    };
  },
  [`${combatTypes.FETCH_UPCOMING_COMBATS_INFO}_SUCCESS`](
    state,
    { goalUID, result }
  ) {
    return {
      ...state,
      upcoming: {
        ...state.upcoming,
        [goalUID]: result
      }
    };
  },
  [`${combatTypes.ENROLL_FOR_CONTEST}_SUCCESS`](
    state,
    { goalUID, contestUID }
  ) {
    const combats = state.upcoming[goalUID]?.results;
    const results = [];

    for (let i = 0; i < combats.length; i += 1) {
      const { programmes, ...rest } = combats[i];
      results[i] = { ...rest };

      const updatedProgrammes = [];
      for (let j = 0; j < programmes.length; j += 1) {
        if (programmes[j].uid === contestUID) {
          updatedProgrammes[j] = {
            ...programmes[j],
            is_enrolled: true
          };
        } else {
          updatedProgrammes[j] = programmes[j];
        }
      }

      results[i].programmes = updatedProgrammes;
    }

    return {
      ...state,
      upcoming: {
        ...state.upcoming,
        [goalUID]: {
          ...state.upcoming[goalUID],
          results
        }
      }
    };
  },
  [`${combatTypes.FETCH_CONTEST_ONBOARDING_PREFERENCES}_SUCCESS`](
    state,
    { goalUID, result }
  ) {
    return {
      ...state,
      onboardingPreferences: {
        ...state.onboardingPreferences,
        [goalUID]: result
      }
    };
  },
  [`${combatTypes.FETCH_COMBAT_DETAILS}_SUCCESS`](
    state,
    { combatUID, result }
  ) {
    return {
      ...state,
      details: {
        ...state.details,
        [combatUID]: result
      }
    };
  }
};

const reducer = (state = initialState, action) => {
  const actionHandler = reducerMap[action.type];
  return actionHandler ? actionHandler(state, action) : state;
};

export default reducer;
